import React from "react"
import { TextSecondaryExtraSmall } from "@mallardbay/lib-react-components"

import packageJson from "~package"

export default function SidebarVersion() {
    const styles = {
        text: {
            textAlign: "center",
        },
    }
    return (
        <TextSecondaryExtraSmall style={styles.text}>
            v{packageJson.version}
        </TextSecondaryExtraSmall>
    )
}
